import clsx from 'clsx';

interface EditorLoadingFallbackProps {
  className?: string;
  showToolbar?: boolean;
}

export function EditorLoadingFallback({
  className,
  showToolbar = true,
}: EditorLoadingFallbackProps) {
  return (
    <div
      className={clsx(
        'flex flex-col border border-border-primary rounded-lg overflow-hidden bg-surface-primary',
        className
      )}
      role="status"
      aria-label="Loading editor"
    >
      {/* Toolbar skeleton */}
      {showToolbar && (
        <div className="flex items-center gap-1 p-2 border-b border-border-primary bg-surface-secondary">
          {/* Button groups skeleton */}
          <div className="flex gap-1">
            {[...Array(3)].map((_, i) => (
              <div
                key={`group1-${i}`}
                className="h-8 w-8 bg-surface-tertiary rounded animate-pulse"
              />
            ))}
          </div>
          <div className="w-px h-6 bg-border-primary mx-1" />
          <div className="flex gap-1">
            {[...Array(3)].map((_, i) => (
              <div
                key={`group2-${i}`}
                className="h-8 w-8 bg-surface-tertiary rounded animate-pulse"
              />
            ))}
          </div>
          <div className="w-px h-6 bg-border-primary mx-1" />
          <div className="flex gap-1">
            {[...Array(2)].map((_, i) => (
              <div
                key={`group3-${i}`}
                className="h-8 w-8 bg-surface-tertiary rounded animate-pulse"
              />
            ))}
          </div>
        </div>
      )}

      {/* Content skeleton */}
      <div className="flex-1 p-4 min-h-[200px]">
        <div className="space-y-3">
          {/* Simulating text lines */}
          <div className="h-4 bg-surface-tertiary rounded animate-pulse w-3/4" />
          <div className="h-4 bg-surface-tertiary rounded animate-pulse w-full" />
          <div className="h-4 bg-surface-tertiary rounded animate-pulse w-5/6" />
          <div className="h-4 bg-surface-tertiary rounded animate-pulse w-4/5 mt-6" />
          <div className="h-4 bg-surface-tertiary rounded animate-pulse w-full" />
          <div className="h-4 bg-surface-tertiary rounded animate-pulse w-2/3" />
        </div>
      </div>

      {/* Screen reader text */}
      <span className="sr-only">Loading editor...</span>
    </div>
  );
}
